define('models/accounts/allocations',[ "backbone" ], function (Backbone) {

    var Allocations = Backbone.Model.extend({
        url: function () {
            return pf.userURL + 's/' + pf.session.get('UserGUID') + '/Allocations';
        },
        initialize: function (options) {
            options || (options = {});
        },
        parse: function (data) {
            var response = {};
            
            return response;
        },
        save: function (attributes, options) {
            options = options || {};
            attributes = attributes || {};;

            var data = {};

            // data.allocations = this.allocations;

            this.attributes = data;

            return Backbone.Model.prototype.save.call(this, attributes, options);
        }
    });

    return Allocations;
});
